import { render, staticRenderFns } from "./TotalUniqueDriversPerMonth.vue?vue&type=template&id=055defb2&"
import script from "./TotalUniqueDriversPerMonth.vue?vue&type=script&lang=ts&"
export * from "./TotalUniqueDriversPerMonth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports